module.exports = __webpack_public_path__ + "18bcf93f900a87ac51313a0855536261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/images/avatar-little.svg
// module id = ./src/components/Home/images/avatar-little.svg
// module chunks = 2